export default function Pricing() {
  const scrollToDiagnostic = () => {
    const element = document.getElementById('diagnostic-section');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Investimento Acessível
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Plano mensal com ticket baixo e alto valor percebido. 
            Transforme seu negócio sem comprometer o caixa
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-primary-600 to-primary-700 rounded-3xl p-12 text-white shadow-2xl relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-coral-500 opacity-10 rounded-full -mr-32 -mt-32"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-coral-500 opacity-10 rounded-full -ml-24 -mb-24"></div>

            <div className="relative z-10">
              <div className="text-center mb-8">
                <h3 className="text-3xl font-bold mb-4">LBAs Essentials</h3>
                <p className="text-xl opacity-90">Programa Completo de 10-12 Meses</p>
              </div>

              <div className="text-center mb-12">
                <div className="inline-block">
                  <div className="text-6xl font-bold mb-2">
                    Consulte
                  </div>
                  <div className="text-xl opacity-90">Valor personalizado para seu negócio</div>
                </div>
              </div>

              {/* Features Grid */}
              <div className="grid md:grid-cols-2 gap-6 mb-12">
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-coral-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-lg">Diagnóstico completo inicial</span>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-coral-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-lg">Mapeamento de processos</span>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-coral-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-lg">Reuniões mensais de acompanhamento</span>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-coral-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-lg">Plano de ação personalizado</span>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-coral-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-lg">Suporte via WhatsApp</span>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-coral-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-lg">Relatórios de evolução</span>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-coral-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-lg">Ferramentas de gestão</span>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-coral-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-lg">Documentação completa</span>
                </div>
              </div>

              <div className="text-center">
                <button
                  onClick={scrollToDiagnostic}
                  className="px-10 py-4 bg-coral-500 text-white rounded-lg font-bold text-lg hover:bg-coral-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  Solicitar Proposta Personalizada
                </button>
                <p className="mt-4 text-sm opacity-75">
                  Diagnóstico gratuito • Sem compromisso • Resposta em 24h
                </p>
              </div>
            </div>
          </div>

          {/* Additional Info Cards */}
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            <div className="bg-gradient-to-br from-primary-50 to-blue-50 rounded-xl p-6 text-center">
              <div className="w-12 h-12 bg-coral-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Garantia de Resultados</h4>
              <p className="text-sm text-gray-600">Metodologia comprovada com resultados mensuráveis</p>
            </div>
            <div className="bg-gradient-to-br from-primary-50 to-blue-50 rounded-xl p-6 text-center">
              <div className="w-12 h-12 bg-coral-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-check-line text-2xl text-white"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Flexibilidade</h4>
              <p className="text-sm text-gray-600">Pagamento mensal sem fidelidade obrigatória</p>
            </div>
            <div className="bg-gradient-to-br from-primary-50 to-blue-50 rounded-xl p-6 text-center">
              <div className="w-12 h-12 bg-coral-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-2-line text-2xl text-white"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Suporte Total</h4>
              <p className="text-sm text-gray-600">Acompanhamento personalizado durante todo programa</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
